import {Component, Input, OnInit} from '@angular/core';
import {Asset, ASSET_STATUS_MISSING_INFO, AssetSaleInfo} from "../../shared/domain/item";
import {MoveIndicatorControlService} from "../../shared/reload-indicator/move-indicator-control.service";

@Component({
  selector: 'lib-item-error-message',
  templateUrl: './item-error-message.component.html',
  styleUrls: ['./item-error-message.component.css']
})
export class ItemErrorMessageComponent implements OnInit {

  @Input() asset: Asset;
  @Input() assetSaleInfo: AssetSaleInfo;

  public assetMissingInfo = ASSET_STATUS_MISSING_INFO;

  constructor(private moveIndicatorControlService: MoveIndicatorControlService) { }

  ngOnInit(): void {
  }

  public showMe(elementName : string){
    this.moveIndicatorControlService.announce(elementName);
  }

}
